import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateSelectedContract, clearValidationError } from '../../../../../services/ContractService/contractSlice';
import { useGetFacilityTypesQuery } from '../../../../../services/ContractService';

const FacilityTypeEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const contract = useAppSelector((state) => state.contract.currentContract);
  const validationErrors = useAppSelector((state) => state.contract.validationErrors);
  const { data: facilityTypes = [] } = useGetFacilityTypesQuery();

  const handleChange = (value: string) => {
    if (contract) {
      dispatch(updateSelectedContract({ facilityType: value }));
      if (validationErrors.facilityType) {
        dispatch(clearValidationError('facilityType'));
      }
    }
  };

  if (!contract) return null;

  return (
    <FormControl variant="outlined" size="small" error={!!validationErrors.facilityType} sx={{ width: 220 }}>
      <InputLabel>Facility Type *</InputLabel>
      <Select
        value={contract.facilityType}
        onChange={(e) => handleChange(e.target.value)}
        label="Facility Type *"
        sx={{ backgroundColor: 'white' }}
      >
        {facilityTypes.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.name}
          </MenuItem>
        ))}
      </Select>
      {validationErrors.facilityType && (
        <FormHelperText>{validationErrors.facilityType}</FormHelperText>
      )}
    </FormControl>
  );
};

export default FacilityTypeEditor;
